import { render, staticRenderFns } from "./tab-nav.vue?vue&type=template&id=2d974e3c"
import script from "./tab-nav.vue?vue&type=script&lang=js"
export * from "./tab-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports